import { useState, useEffect } from "react";
import Select from "react-select";
import { useUserContext } from "../../context/UserContext.jsx";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import AdditionalDetails from "../onboarding-documents/AdditionalDetailsNew.jsx";
import DocumentTab from "../onboarding-documents/DocumentsTab.jsx";
import InfoGatheringTab from "./LeadJourneyInfoGathering.jsx";
import { useLeadJourneyDetails } from "@/api/lead/useLeadJourneyDetails.jsx";
import { useHunterFarmerList } from "@/api/auth/useHunterFarmerList.js";
import { useGetReferrerList } from "@/api/auth/useGetReferrerList.jsx";
import { apiRequest } from "@/network/apiClient";
import { API_ENDPOINTS } from "@/api/apiEndpoints";
import { LeadJourneyDetailsSkeleton } from "./skeleton/LeadJourneySkeleton.jsx";
import { regionCountryMap } from '../../components/Constants.jsx';

export default function LeadJourneyDetails({ leadOwner, leadID }) {

  const {leadJourneyAPI, initialPayout, refetch} = useLeadJourneyDetails({leadID})
  const {hunterListAPI, farmerListAPI} = useHunterFarmerList()
  // const {referrerList} = useGetReferrerList()
  const { referrerList } = useGetReferrerList(leadJourneyAPI?.lead_source);

  const [leadJourney, setLeadJourney] = useState(null);
  const [hunterList, setHunterList] = useState(null);
  const [farmerList, setFarmerList] = useState(null)
  const [referrerOptions, setReferrerOptions] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  // indication for whether the lead is from an opportunity or not (for sending documents)
  const [fromOpp, setFromOpp] = useState(false);
  const [formData, setFormData] = useState({
    race_of_pic_others: "",
  });

  const role = localStorage.getItem("role");
  const canViewLead = role === 'Admin'
  const canEditLead = role === 'Admin' || role === 'HOD_Hunter'

  
  const [showReassignModal, setShowReassignModal] = useState(false);
  const [showReassignConfirmationModal, setShowReassignConfirmationModal] =
    useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [selectedHunter, setSelectedHunter] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const [fetchedData, setFetchedData] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [UserId, setUserId] = useState(null);
  const [showSaveButtons, setShowSaveButtons] = useState(false);
  const [initialPayoutValue, setInitialPayoutValue] = useState(null);

  const selectClass = (value, base = "") =>
  `${base} ${!value ? "text-gray-400" : "text-black"}`;

  const relationshipStrengthMap = {
    1: {
      label: "Cold",
      icon: <img src="/icons/cold.svg" className="size-8 -mt-1" />,
    }, // Cold
    2: {
      label: "Warm",
      icon: <img src="/icons/warm.svg" className="size-8 -mt-1" />,
    }, // Warm
    3: {
      label: "Hot",
      icon: <img src="/icons/hot.svg" className="size-8 -mt-1" />,
    }, // Hot
  };

  const contactMethodMap = {
    EVENT_IN_PERSON: "Event/In-person",
    CALL: "Call",
    TEXT_MESSAGE: "Text/Message",
    EMAIL: "E-mail",
    SOCIAL_MEDIA: "Social Media",
  };

  const relationshipStrengthSelectMap = {
    "Cold" : "Cold",
    "Warm" : "Warm",
    "Hot" : "Hot",
  };

  // Map between numeric API values and string dropdown values
  const relationshipStrengthNumericMap = {
    1: "Cold",
    2: "Warm",
    3: "Hot",
  };

  const relationshipStrengthStringToNumericMap = {
    "Cold": 1,
    "Warm": 2,
    "Hot": 3,
  };

  const raceOfPicMap = {
    Malay: "Malay",
    Chinese: "Chinese",
    Indian: "Indian",
    Others: "Others",
  };

  const languageMap = {
    BAHASA_MALAYSIA: "Bahasa Malaysia",
    ENGLISH: "English",
    MANDARIN: "Mandarin",
    CANTONESE: "Cantonese",
    HOKKIEN: "Hokkien",
    TAMIL: "Tamil",
  };

  const salutationMap = {
    MR: "Mr.",
    MS: "Ms.",
    MRS: "Mrs.",
  };

  const industryMap = {
    "Agriculture": "Agriculture",
    "Art, Entertainment and Recreation": "Art, Entertainment and Recreation",
    "Automotives & Motorcycles": "Automotives & Motorcycles",
    "Beauty & Wellness": "Beauty & Wellness",
    "Building Cleaning, Pest Control & Gardening Services": "Building Cleaning, Pest Control & Gardening Services",
    "Charity & Voluntary work": "Charity & Voluntary work",
    "Computer Hardware / Software / Electronic Devices": "Computer Hardware / Software / Electronic Devices",
    "Construction": "Construction",
    "Customized Gifts / Souvenirs / Printing": "Customized Gifts / Souvenirs / Printing",
    "Employment Related": "Employment Related",
    "Event Management": "Event Management",
    "Fabric, Apparel & Accessories": "Fabric, Apparel & Accessories",
    "Family & Baby": "Family & Baby",
    "Finance / Investment / Wealth Management": "Finance / Investment / Wealth Management",
    "Food & Beverages - Product": "Food & Beverages - Product",
    "Food and Beverages - Service": "Food and Beverages - Service",
    "Healthcare": "Healthcare",
    "Home Furniture & Hardware Appliances": "Home Furniture & Hardware Appliances",
    "Hospitality / Travel": "Hospitality / Travel",
    "Industrial Goods": "Industrial Goods",
    "Information Technology": "Information Technology",
    "Logistics": "Logistics",
    "Machinery": "Machinery",
    "Management / Administrative": "Management / Administrative",
    "Media / Marketing": "Media / Marketing",
    "Medical & Pharmaceuticals": "Medical & Pharmaceuticals",
    "Oil & Gas": "Oil & Gas",
    "Pets Supplies": "Pets Supplies",
    "Real Estate": "Real Estate",
    "Regulatory (Legal / Accounting)": "Regulatory (Legal / Accounting)",
    "Research / Consultancy": "Research / Consultancy",
    "Religious Services": "Religious Services",
    "Sales": "Sales",
    "Science & Education": "Science & Education",
    "Security": "Security",
    "Sports, Hobbies & Recreation": "Sports, Hobbies & Recreation",
    "Telecommunications": "Telecommunications",
    "Transportation": "Transportation",
    "Weapons / Defence / Aerospace": "Weapons / Defence / Aerospace",
    "Others": "Others",
  };

  const natureOfBusinessMap = {
    "Agencies / Intermediaries / other services": "Agencies / Intermediaries / other services",
    "Distributor": "Distributor",
    "Manufacturing": "Manufacturing",
    "Non-Profit": "Non-Profit",
    "Professional Services": "Professional Services",
    "Retail": "Retail",
    "Trading": "Trading",
  };


  const countryCodes = [
    { value: "+60", label: "+60 (Malaysia)" },
    { value: "+65", label: "+65 (Singapore)" },
    { value: "+62", label: "+62 (Indonesia)" },
    { value: "+66", label: "+66 (Thailand)" },
    { value: "+63", label: "+63 (Philippines)" },
    { value: "+84", label: "+84 (Vietnam)" },
    { value: "+1", label: "+1 (US/Canada)" },
    { value: "+44", label: "+44 (UK)" },
    { value: "+61", label: "+61 (Australia)" },
    { value: "+86", label: "+86 (China)" },
    { value: "+91", label: "+91 (India)" },
    { value: "+81", label: "+81 (Japan)" },
    { value: "+82", label: "+82 (South Korea)" },
    { value: "+852", label: "+852 (Hong Kong)" },
    { value: "+853", label: "+853 (Macau)" },
  ];

  const getReferralOwner = (referrerID) => {
    const referrer = farmerList.find(u => u.user_id === referrerID)
    return (referrer ? referrer.username : "Unknown User")
  }

  const handleRelationshipStrengthChange = (e) => {
    const stringValue = e.target.value; // Get string value from dropdown
    const numericValue = relationshipStrengthStringToNumericMap[stringValue]; // Convert to numeric for API
    setFormData((prevState) => ({
      ...prevState,
      interest_level: numericValue,
    }));
  };

  // Helper function to parse mobile number into country code and number
  const parseMobileNumber = (mobileNo) => {
    if (!mobileNo) return { countryCode: "+60", number: "" };
    
    // Try to find a matching country code
    for (const code of countryCodes) {
      if (mobileNo.startsWith(code.value)) {
        return {
          countryCode: code.value,
          number: mobileNo.substring(code.value.length).trim(),
        };
      }
    }
    
    // Default to Malaysia if no match found
    return { countryCode: "+60", number: mobileNo };
  };

  const parseLanguages = (languageString) => {
    if (!languageString) return [];
    const languages = languageString.split(',').map(lang => lang.trim()).filter(lang => lang);
    
    return languages.map(lang => {
      if (languageMap[lang]) {
        return lang;
      }
      const enumKey = Object.keys(languageMap).find(key => languageMap[key] === lang);
      return enumKey || lang; // Return enum key if found, otherwise keep original
    });
  };

  const languagesToString = (languages) => {
    if (!languages || languages.length === 0) return "";
    return languages.map(key => languageMap[key] || key).join(', ');
  };

  useEffect(() => {
    if (leadJourneyAPI){
      setLeadJourney(leadJourneyAPI)
      const parsedMobile = parseMobileNumber(leadJourneyAPI.mobile_no);
      const parsedLanguages = parseLanguages(leadJourneyAPI.language);
      setFormData({
        ...leadJourneyAPI,
        mobile_country_code: parsedMobile.countryCode,
        mobile_no: parsedMobile.number,
        languages: parsedLanguages,
      });
    }
    if (initialPayout){
      setInitialPayoutValue(initialPayout)
    }

    setHunterList(hunterListAPI);
    setFarmerList(farmerListAPI)
    setReferrerOptions(referrerList);
  }, [leadJourneyAPI, initialPayout, hunterListAPI, farmerListAPI, referrerList]);

  const handleEditClick = () => {
    setIsEditing(!isEditing);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // const formattedValue = formatDateForDisplay(value);

    if (name === "hunter_id") {
      // Cross-reference the hunter_name with the hunterList
      const hunter = hunterList.find((h) => h.username === value);
      if (hunter) {
        setFormData((prevState) => ({
          ...prevState,
          hunter_id: hunter.id,
          hunter_name: value,
        }));
      } else {
        setFormData((prevState) => ({
          ...prevState,
          hunter_id: null,
          hunter_name: value,
        }));
      }
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleLanguageChange = (languageKey) => {
    setFormData((prevState) => {
      const currentLanguages = prevState.languages || [];
      const isSelected = currentLanguages.includes(languageKey);
      
      let updatedLanguages;
      if (isSelected) {
        updatedLanguages = currentLanguages.filter(lang => lang !== languageKey);
      } else {
        updatedLanguages = [...currentLanguages, languageKey];
      }
      
      return {
        ...prevState,
        languages: updatedLanguages,
      };
    });
  };

  const handleSubmit = () => {
    setShowReassignConfirmationModal(true);
  };

  const handleReassignConfirmation = async (e) => {
    e.preventDefault();
    
    // Referrer validation
    const needsReferrerField = ["Referral Margin Sharing", "Referral MM Employee"].includes(leadJourney.lead_source);
    const needsReferrerNameField = ["Referral Public"].includes(leadJourney.lead_source);
    
    if (needsReferrerField && !formData.referrer) {
      toast.error("Please select a referrer before saving.");
      setShowReassignConfirmationModal(false);
      return;
    }
    if (needsReferrerNameField && !formData.referrer_name) {
      toast.error("Please enter a referrer name before saving.");
      setShowReassignConfirmationModal(false);
      return;
    }
    // Validate email using HTML5 validation
    if (formData.email) {
      const emailInput = document.querySelector('input[name="email"]');
      if (emailInput && !emailInput.validity.valid) {
        emailInput.reportValidity();
        return;
      }
    }
    
    // Combine mobile country code and number before sending
    // Convert languages array to comma-separated string
    const submitData = {
      ...formData,
      mobile_no: formData.mobile_country_code && formData.mobile_no 
        ? `${formData.mobile_country_code}${formData.mobile_no}` 
        : formData.mobile_no,
      language: languagesToString(formData.languages || []),
    };
    delete submitData.mobile_country_code;
    delete submitData.languages;
    
    // Send the updated formData to the backend
    try{
      const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.UPDATE_LEADS.LEAD_JOURNEY}?lead_id=${leadID}`, 'POST', submitData)

      if (result) {
        setIsEditing(false);
        refetch();
        setLeadJourney(leadJourneyAPI);
        const parsedMobile = parseMobileNumber(leadJourneyAPI.mobile_no);
        const parsedLanguages = parseLanguages(leadJourneyAPI.language);
        setFormData({
          ...leadJourneyAPI,
          mobile_country_code: parsedMobile.countryCode,
          mobile_no: parsedMobile.number,
          languages: parsedLanguages,
        });
      }
      toast.success('Lead details successfully saved')
    } catch (error){
      toast.error(error || 'Unable to save data')
      console.error("Error updating lead details: ", error)
    }finally{
      setShowReassignConfirmationModal(false);
    }

  };

  const handleCancel = () => {
    setIsEditing(false); // Exit edit mode
    const parsedMobile = parseMobileNumber(leadJourney.mobile_no);
    const parsedLanguages = parseLanguages(leadJourney.language);
    setFormData({
      ...leadJourney,
      mobile_country_code: parsedMobile.countryCode,
      mobile_no: parsedMobile.number,
      languages: parsedLanguages,
    }); // Revert form data back to the original leadJourney data
    setShowSaveButtons(false);
  };

  const handleReassignClick = () => {
    setShowReassignModal(true); // Show the reassign modal
  };

  const handleReassignSubmit = () => {
    // Find the selected hunter's details from hunterList
    const selectedHunterDetails = hunterList.find(
      (h) => h.username === selectedHunter
    );
    if (selectedHunterDetails) {
      // Update formData with the selected hunter's id and username
      setFormData((prevState) => ({
        ...prevState,
        hunter_id: selectedHunterDetails.id,
        hunter_name: selectedHunterDetails.username,
      }));
    }

    setShowReassignModal(false); // Close the reassign modal
    setShowConfirmationModal(true); // Show the confirmation modal
  };

  const handleConfirmationSubmit = async (e) => {
    e.preventDefault();

    try {
      const result = await apiRequest(
        `${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.UPDATE_LEADS.REASSIGN_HUNTER}?lead_id=${leadID}`,
        'POST',
        { hunter_id: formData.hunter_id }
      )
      if (result) {
        refetch();
      }
      toast.success('Lead owner successfully updated')
    } catch (error) {
      toast.error(error || 'Error updating owner')
    } finally {
      setShowConfirmationModal(false)
    }
  };

  const handleConfirmationCancel = () => {
    setShowConfirmationModal(false); // Close the confirmation modal
    setShowReassignConfirmationModal(false);
  };

  
  const racesList = ["Malay", "Chinese", "Indian", "Others"]; // Add more races as needed


  const racesOptions = racesList.map((race) => ({
    value: race,
    label: race,
  }));


  const handlePayoutCheckboxChange = (e) => {
    if (!isEditing) return;

    const isQualified = e.target.checked ? 1 : 0;
    setFormData((prev) => ({
      ...prev,
      payout: isQualified,
    }));

    console.log(isQualified);
    // Show save buttons only if the value has changed from initial
    setShowSaveButtons(isQualified !== initialPayoutValue);
  };

  // const handleDropdownChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     [name]: value,
  //   }));
  // };

  // Update the handleDropdownChange function to store the referrer ID
const handleDropdownChange = (e) => {
  const { name, value } = e.target;
  
  if (name === "referrer") {
    // Find the selected referrer's ID
    const selectedReferrer = referrerOptions.find((ref) => ref.name === value);
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
      ref_lead_id: selectedReferrer ? selectedReferrer.id : null, // Store the ID
    }));
  } else {
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }
};



  if (!leadJourney) {
    return (
      <LeadJourneyDetailsSkeleton/>
    );
  }

  const relationshipStrength = leadJourney.interest_level; // Assuming this is the field in your data
  const { label, icon } = relationshipStrengthMap[relationshipStrength] || {
    label: "Unknown",
    icon: "❓",
  };

  let tabs = ['Details', 'Info Gathering', 'Onboarding'];

  if (leadOwner || canViewLead){
    if ([0,1,6].includes(Number(leadJourney.status))){
      tabs = ['Details']
    }else if([2].includes(Number(leadJourney.status))){
      tabs = ['Details','Info Gathering']
    }else if ([3,4,5].includes(Number(leadJourney.status))){
      tabs = ['Details','Info Gathering', 'Onboarding']
    }
  }else if (!leadOwner ){
    if ([0,1,6].includes(Number(leadJourney.status))){
      tabs = ['Details']
    }else{
      tabs = ['Details','Info Gathering']
    }
  }

  return (
    <div className="w-full flex justify-between items-center ml-0 md:ml-2">
      {/* Inner Grey Container */}
      <div className="p-2 md:p-4 rounded-3xl w-full mr-0 md:mr-2">
        {/* Tabs Container */}
        <div className="flex space-x-4 md:space-x-6 ml-1 md:ml-3 overflow-x-auto scrollbar-hide">
          {tabs.map((tab, index) => (
            <button
              key={index}
              onClick={() => {
                setActiveTab(index); // Set the active tab
              }}
              className={`relative text-sm md:text-md font-medium pb-1 transition-all mb-3 whitespace-nowrap min-h-[44px] md:min-h-0 flex items-end ${
                activeTab === index
                  ? "text-black border-b-4 pl-2 pr-2 border-yellow-300"
                  : "text-gray-500"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Dynamic Content Based on Active Tab */}
        {activeTab === 0 && leadJourney && (
          <div className="w-full bg-white p-4 md:p-7 rounded-2xl md:rounded-3xl shadow-lg">
            {/* Lead Ownership Section */}
            <div className="flex justify-between items-start gap-2">
              <div className="flex items-center">
                <p className="font-bold text-lg md:text-2xl">Lead Ownership</p>
              </div>
              <div className="flex space-x-2 flex-shrink-0">
                {isEditing && (
                  <button
                    className="group bg-white text-black p-2 md:p-3 rounded-full border-[1px] border-black hover:bg-gray-200 transition flex items-center justify-center w-11 h-11 md:w-12 md:h-12"
                    onClick={handleCancel}
                    aria-label="Cancel Editing"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="w-5 h-5 md:w-6 md:h-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18 18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                )}

                {leadOwner || canViewLead &&
                ![4, 5, 6].includes(leadJourney.status) ? (
                  <button
                    className="group bg-white text-black p-2 md:p-3 rounded-full border-[1px] border-black hover:bg-yellow-300 transition flex items-center justify-center w-11 h-11 md:w-12 md:h-12"
                    onClick={isEditing ? handleSubmit : handleEditClick}
                    aria-label={isEditing ? "Submit" : "Edit Lead"}
                  >
                    {isEditing ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="w-5 h-5 md:w-6 md:h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="m4.5 12.75 6 6 9-13.5"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="w-5 h-5 md:w-6 md:h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
                        />
                      </svg>
                    )}
                  </button>
                ) : null}
              </div>
            </div>

            {/* Grid Container for All Rows */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3 md:gap-x-5 ml-2 md:ml-5">
              {/* Company Name and Hunter */}
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Company Name</b> <a className="text-[#DD3730]">*</a>
                  </span>
                  {isEditing ? (
                    <input
                      type="text"
                      name="company_name"
                      value={formData.company_name || ""}
                      onChange={handleChange}
                      className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                    />
                  ) : (
                    <span className="flex-1">{leadJourney.company_name}</span>
                  )}
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(leadJourney.company_name);
                      toast.success("Copied to clipboard!");
                    }}
                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <img src="/icons/content_copy.svg" className="size-6" />
                  </button>
                </div>
              </div>
              <div className="flex items-start mt-3 md:mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-2 md:gap-0">
                  <span className="w-full md:w-1/3 text-sm md:text-base">
                    <b>Hunter</b>
                  </span>
                  <span className="flex-1 text-sm md:text-base">{leadJourney.hunter_name}</span>
                  {((leadOwner && ![4, 5, 6].includes(leadJourney.status)) ||
                    (canEditLead && ![6].includes(leadJourney.status))) && (
                    <button
                      onClick={handleReassignClick}
                      className="text-[#5D65F8] underline hover:text-[#4A52E6] focus:outline-none mr-2 font-bold text-xs md:text-sm min-h-[44px] md:min-h-0 flex items-center"
                    >
                      Reassign
                    </button>
                  )}
                </div>
              </div>

              {/* Contact Method and Lead Source */}
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Contact Method</b>
                  </span>
                  {isEditing ? (
                    <select
                      name="contact_method"
                      value={formData.contact_method || ""}
                      onChange={handleChange}
                      className={selectClass(formData.contact_method, "flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left")}
                    >
                      <option value="">Select Contact Method</option>
                      {Object.entries(contactMethodMap).map(([value, label]) => (
                        <option key={value} value={value}>
                          {label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <span className="flex-1">
                      {contactMethodMap[leadJourney.contact_method] || leadJourney.contact_method}
                    </span>
                  )}
                </div>
              </div>
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Lead Source</b>
                  </span>
                  <span className="flex-1">{leadJourney.lead_source}</span>
                </div>
              </div>
              {['Referral Active', 'Referral Special', 'Referral F&F'].includes(leadJourney.lead_source) ? (
                <div className="col-span-1 md:col-span-2 flex items-start mt-3 md:mt-5">
                  <div className="border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-2 md:gap-0">
                    <span className="w-full md:w-1/6 text-sm md:text-base">
                      <b>Referral Owner</b>
                    </span>
                      <span className="flex-1 md:-ml-1 text-sm md:text-base">{leadJourney?.farmer_name}</span>
                  </div>
                </div>
              ): null}

              <div className="flex items-center mt-4 md:mt-5 mb-2 col-span-1 md:col-span-2">
                <p className="font-bold text-lg md:text-2xl -ml-2 md:-ml-5 w-full">
                  Lead Profile
                </p>
              </div>
              {/* Name and Email */}
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Name</b> <a className="text-[#DD3730]">*</a>
                  </span>
                  {isEditing ? (
                    <div className="flex-1 flex items-center gap-2">
                      <select
                        name="salutation"
                        value={formData.salutation || ""}
                        onChange={handleChange}
                        className={selectClass(formData.salutation, "flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left")}
                      >
                        <option value="">Select</option>
                        {Object.entries(salutationMap).map(([key, label]) => (
                          <option key={key} value={key}>
                            {label}
                          </option>
                        ))}
                      </select>
                      <input
                        type="text"
                        name="name"
                        value={formData.name || ""}
                        onChange={handleChange}
                        className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                      />
                    </div>
                  ) : (
                    <span className="flex-1">
                      {(() => {
                        const salutation = formData.salutation ? salutationMap[formData.salutation] : (leadJourney.salutation ? salutationMap[leadJourney.salutation] : "");
                        const name = formData.name || leadJourney.name || "";
                        return salutation ? `${salutation} ${name}` : name;
                      })()}
                    </span>
                  )}
                  <button
                    onClick={() => {
                      const salutation = formData.salutation ? salutationMap[formData.salutation] : (leadJourney.salutation ? salutationMap[leadJourney.salutation] : "");
                      const name = formData.name || leadJourney.name || "";
                      const fullName = salutation ? `${salutation} ${name}` : name;
                      navigator.clipboard.writeText(fullName);
                      toast.success("Copied to clipboard!");
                    }}
                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <img src="/icons/content_copy.svg" className="size-6" />
                  </button>
                </div>
              </div>
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Email</b>
                  </span>
                  {isEditing ? (
                    <input
                      type="email"
                      name="email"
                      value={formData.email || ""}
                      onChange={handleChange}
                      className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                      placeholder="example@email.com"
                    />
                  ) : (
                    <span className="flex-1">{leadJourney.email}</span>
                  )}
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(leadJourney.email);
                      toast.success("Copied to clipboard!");
                    }}
                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <img src="/icons/content_copy.svg" className="size-6" />
                  </button>
                </div>
              </div>

              {/* Mobile (Personal) and Phone (Office) */}
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Mobile (Personal)</b> <a className="text-[#DD3730]">*</a>
                  </span>
                  {isEditing ? (
                    <div className="flex-1 flex gap-2">
                      <select
                        name="mobile_country_code"
                        value={formData.mobile_country_code || "+60"}
                        onChange={handleChange}
                        className={selectClass(formData.mobile_country_code, "flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left")}
                      >
                        {countryCodes.map((code) => (
                          <option key={code.value} value={code.value}>
                            {code.value}
                          </option>
                        ))}
                      </select>
                      <input
                        type="tel"
                        name="mobile_no"
                        value={formData.mobile_no || ""}
                        onChange={handleChange}
                        placeholder="Enter phone number"
                        className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                      />
                    </div>
                  ) : (
                    <span className="flex-1">
                      {formData.mobile_country_code && formData.mobile_no
                        ? `${formData.mobile_country_code}${formData.mobile_no}`
                        : leadJourney.mobile_no || ""}
                    </span>
                  )}
                  <button
                    onClick={() => {
                      const mobileToCopy = formData.mobile_country_code && formData.mobile_no
                        ? `${formData.mobile_country_code}${formData.mobile_no}`
                        : leadJourney.mobile_no;
                      navigator.clipboard.writeText(mobileToCopy);
                      toast.success("Copied to clipboard!");
                    }}
                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <img src="/icons/content_copy.svg" className="size-6" />
                  </button>
                </div>
              </div>
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Phone (Office)</b>
                  </span>
                  {isEditing ? (
                    <input
                      type="text"
                      name="office_no"
                      value={formData.office_no || ""}
                      onChange={handleChange}
                      className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                    />
                  ) : (
                    <span className="flex-1">{leadJourney.office_no}</span>
                  )}
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(leadJourney.office_no);
                      toast.success("Copied to clipboard!");
                    }}
                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <img src="/icons/content_copy.svg" className="size-6" />
                  </button>
                </div>
              </div>
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Position</b> <a className="text-[#DD3730]">*</a>
                  </span>
                  {isEditing ? (
                    <div className="flex-1 flex gap-2">
                      <input
                        name="designation"
                        value={formData.designation || ""}
                        onChange={handleChange}
                        placeholder="Manager, Founder ect."
                        className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                      />
                    </div>
                  ) : (
                    <span className="flex-1">{leadJourney.designation}</span>
                  )}
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(leadJourney.designation);
                      toast.success("Copied to clipboard!");
                    }}
                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <img src="/icons/content_copy.svg" className="size-6" />
                  </button>
                </div>
              </div>
              {/* Language(s) */}
              <div className=" flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Language(s)</b> <a className="text-[#DD3730]">*</a>
                  </span>
                  {isEditing ? (
                    <div className="flex-1 flex flex-wrap gap-3">
                      {Object.entries(languageMap).map(([key, label]) => (
                        <label key={key} className="flex items-center gap-2 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={(formData.languages || []).includes(key)}
                            onChange={() => handleLanguageChange(key)}
                            className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
                          />
                          <span className="text-sm">{label}</span>
                        </label>
                      ))}
                    </div>
                  ) : (
                    <span className="flex-1">
                      {formData.languages && formData.languages.length > 0
                        ? formData.languages.map(key => languageMap[key]).filter(Boolean).join(', ')
                        : leadJourney.language || ""}
                    </span>
                  )}
                </div>
              </div>

              {/* Nature of Business and Industry */}
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Nature of Business</b> <a className="text-[#DD3730]">*</a>
                  </span>
                  {isEditing ? (
                    <select
                      name="nature_of_business"
                      value={formData.nature_of_business || ""}
                      onChange={handleChange}
                      className={selectClass(formData.nature_of_business, "flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left")}
                    >
                      <option value="">Select Nature of Business</option>
                      {Object.entries(natureOfBusinessMap).map(([key, label]) => (
                        <option key={key} value={key}>
                          {label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <span className="flex-1">
                      {natureOfBusinessMap[leadJourney.nature_of_business] || leadJourney.nature_of_business}
                    </span>
                  )}
                </div>
              </div>
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Industry</b> <a className="text-[#DD3730]">*</a>
                  </span>
                  {isEditing ? (
                    <select
                      name="industry"
                      value={formData.industry || ""}
                      onChange={handleChange}
                      className={selectClass(formData.industry, "flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left")}
                    >
                      <option value="">Select Industry</option>
                      {Object.entries(industryMap).map(([key, label]) => (
                        <option key={key} value={key}>
                          {label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <span className="flex-1">
                      {industryMap[leadJourney.industry] || leadJourney.industry}
                    </span>
                  )}
                </div>
              </div>

              {/* Relationship Strength */}
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Relationship Strength</b>
                  </span>
                  {isEditing ? (
                    <select
                      name="interest_level"
                      value={relationshipStrengthNumericMap[formData.interest_level] || ""}
                      onChange={handleRelationshipStrengthChange}
                      className={selectClass(relationshipStrengthNumericMap[formData.interest_level], "flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left")}
                    >
                      <option value="">Select Relationship Strength</option>
                      {Object.entries(relationshipStrengthSelectMap).map(([value, label]) => (
                        <option key={value} value={value}>
                          {label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    // <span className="flex-1">{leadJourney.interest_level}</span>
                    <span className="flex-1 inline-flex items-center">
                      {icon} <span className="ml-1">{label}</span>
                    </span>
                  )}
                </div>
              </div>

              {/* Street */}
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Street</b>
                  </span>
                  {isEditing ? (
                    <input
                      type="text"
                      name="street"
                      value={formData.street || ""}
                      onChange={handleChange}
                      className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                    />
                  ) : (
                    <span className="flex-1">{leadJourney.street}</span>
                  )}
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(leadJourney.street);
                      toast.success("Copied to clipboard!");
                    }}
                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <img src="/icons/content_copy.svg" className="size-6" />
                  </button>
                </div>
              </div>

              {/* City */}
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>City</b> <a className="text-[#DD3730]">*</a>
                  </span>
                  {isEditing ? (
                    <input
                      type="text"
                      name="city"
                      value={formData.city || ""}
                      onChange={handleChange}
                      className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                    />
                  ) : (
                    <span className="flex-1">{leadJourney.city}</span>
                  )}
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(leadJourney.city);
                      toast.success("Copied to clipboard!");
                    }}
                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <img src="/icons/content_copy.svg" className="size-6" />
                  </button>
                </div>
              </div>

              {/* Post Code */}
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Post Code</b>
                  </span>
                  {isEditing ? (
                    <input
                      type="text"
                      name="postal_code"
                      value={formData.postal_code || ""}
                      onChange={handleChange}
                      className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                    />
                  ) : (
                    <span className="flex-1">
                      {leadJourney.postal_code}
                    </span>
                  )}
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(leadJourney.postal_code);
                      toast.success("Copied to clipboard!");
                    }}
                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <img src="/icons/content_copy.svg" className="size-6" />
                  </button>
                </div>
              </div>

              {/* State */}
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>State</b>
                  </span>
                  {isEditing ? (
                    <input
                      type="text"
                      name="state"
                      value={formData.state || ""}
                      onChange={handleChange}
                      className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                    />
                  ) : (
                    <span className="flex-1">{leadJourney.state}</span>
                  )}
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(leadJourney.state);
                      toast.success("Copied to clipboard!");
                    }}
                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <img src="/icons/content_copy.svg" className="size-6" />
                  </button>
                </div>
              </div>

              {/* Region/Country */}
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Region/Country</b> <a className="text-[#DD3730]">*</a>
                  </span>
                  {isEditing ? (
                    <select
                      name="region"
                      value={formData.region || ""}
                      onChange={handleChange}
                      className={selectClass(formData.region, "flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left")}
                    >
                      <option value="">Select Region/Country</option>
                      {Object.entries(regionCountryMap).map(([key, label]) => (
                        <option key={key} value={key}>
                          {label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <span className="flex-1">
                      {regionCountryMap[leadJourney.region] || leadJourney.region || "Not Selected"}
                    </span>
                  )}
                </div>
              </div>

              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex items-center mb-5">
                  <span className="w-1/3">
                    <b>Race of PIC</b>
                  </span>
                  {isEditing ? (
                    <select
                      name="race_of_pic"
                      value={formData.race_of_pic || ""}
                      onChange={handleChange}
                      className={selectClass(formData.race_of_pic, "flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left")}
                    >
                      <option value="">Select Race</option>
                      {Object.entries(raceOfPicMap).map(([value, label]) => (
                        <option key={value} value={value}>
                          {label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <span className="flex-1">
                      {raceOfPicMap[leadJourney.race_of_pic] || leadJourney.race_of_pic}
                    </span>
                  )}
                </div>
              </div>

              {/* Conditionally render the "If Others, Specify" field */}
              {formData.race_of_pic === "Others" && (
                <div className="flex items-start mt-5">
                  <div className="border-b border-gray-200 pb-2 w-full flex items-center mb-5">
                    <span className="w-1/3">
                      <b>If Others, Specify</b>
                    </span>
                    {isEditing ? (
                      <input
                        type="text"
                        name="race_of_pic_others"
                        value={formData.race_of_pic_others || ""}
                        onChange={handleChange}
                        className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                      />
                    ) : (
                      <span className="flex-1">
                        {leadJourney.race_of_pic_others}
                      </span>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Referrer Details for Referral Margin Sharing Section */}
            {leadJourney.lead_source === "Referral Margin Sharing" && (
              <div>
                <div className="flex justify-between">
                  <div className="flex items-center">
                    <p className="font-bold text-lg md:text-2xl">Referrer Details</p>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3 md:gap-x-5 ml-2 md:ml-5 items-start mb-5">
                  <div className="flex items-start mt-5">
                    <div className="border-b border-gray-200 pb-2 w-full flex">
                      <span className="w-1/3">
                        <b>Referrer</b> <a className="text-[#DD3730]">*</a>
                      </span>
                      {isEditing ? (
                        <select
                          name="referrer"
                          value={formData.referrer || ""}
                          onChange={handleDropdownChange}
                          className={selectClass(formData.referrer, "flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left")}
                        >
                          <option value="">Select Referrer</option>
                          {referrerOptions.map((referrer) => (
                            <option key={referrer.id} value={referrer.name}>
                              {referrer.name}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <div className="flex-1 flex items-center">
                          <span>{leadJourney.referrer}</span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="flex items-start mt-5">
                    <div className="border-b border-gray-200 pb-2 w-full flex">
                      <span className="w-1/3">
                        <b>Lead Owner</b>
                      </span>
                      <span className="flex-1">{leadJourney.hunter_name}</span>
                    </div>
                  </div>

                  {/* Bank Name & Account Number */}
                  <div className="flex items-start mt-5">
                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/3"><b>Bank Name</b></span>
                        {isEditing ? (
                            <input
                                type="text"
                                name="referrer_bank_name"
                                value={formData.referrer_bank_name || ''}
                                onChange={handleChange}
                                className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                            />
                        ) : (
                            <span className="flex-1">{leadJourney.referrer_bank_name}</span>
                        )}
                        <button
                            onClick={() => {
                                navigator.clipboard.writeText(leadJourney.referrer_bank_name);
                                toast.success('Copied to clipboard!');
                            }}
                            className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                                <img src="/icons/content_copy.svg" className='size-6'/>
                        </button>
                    </div>
                  </div>
                  <div className="flex items-start mt-5">
                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/3"><b>Bank Account Name</b></span>
                        {isEditing ? (
                            <input
                                type="text"
                                name="referrer_bank_acc_name"
                                value={formData.referrer_bank_acc_name || ''}
                                onChange={handleChange}
                                className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                            />
                        ) : (
                            <span className="flex-1">{leadJourney.referrer_bank_acc_name}</span>
                        )}
                        <button
                            onClick={() => {
                                navigator.clipboard.writeText(leadJourney.referrer_bank_name);
                                toast.success('Copied to clipboard!');
                            }}
                            className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                                <img src="/icons/content_copy.svg" className='size-6'/>
                        </button>
                    </div>
                  </div>
                  <div className="flex items-start mt-5">
                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/3"><b>Bank Account Number</b></span>
                        {isEditing ? (
                            <input
                                type="text"
                                name="referrer_bank_acc_no"
                                value={formData.referrer_bank_acc_no || ''}
                                onChange={handleChange}
                                className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                            />
                        ) : (
                            <span className="flex-1">{leadJourney.referrer_bank_acc_no}</span>
                        )}
                        <button
                            onClick={() => {
                                navigator.clipboard.writeText(leadJourney.referrer_bank_acc_no);
                                toast.success('Copied to clipboard!');
                            }}
                            className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                                <img src="/icons/content_copy.svg" className='size-6'/>
                        </button>
                    </div>
                  </div>
              </div> 
            </div>
            )}

            {/* Referrer Details for Referral MM Employee Section */}
            {leadJourney.lead_source === "Referral MM Employee" && (
              <div>
                <div className="flex justify-between">
                  <div className="flex items-center">
                    <p className="font-bold text-lg md:text-2xl">Referrer Details</p>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3 md:gap-x-5 ml-2 md:ml-5 items-start mb-5">
                  <div className="flex items-start mt-5">
                    <div className="border-b border-gray-200 pb-2 w-full flex">
                      <span className="w-1/3">
                        <b>Referrer</b> <a className="text-[#DD3730]">*</a>
                      </span>
                      {isEditing ? (
                        <select
                          name="referrer"
                          value={formData.referrer || ""}
                          onChange={handleDropdownChange}
                          className={selectClass(formData.referrer, "flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left")}
                        >
                            <option value="">Select Referrer</option>
                            {referrerOptions.map((referrer) => (
                              <option key={referrer.id} value={referrer.name}>
                                {referrer.name}
                              </option>
                          ))}
                        </select>
                      ) : (
                        <div className="flex-1 flex items-center">
                          <span>{leadJourney.referrer}</span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="flex items-start mt-5">
                    <div className="border-b border-gray-200 pb-2 w-full flex">
                      <span className="w-1/3">
                        <b>Lead Owner</b>
                      </span>
                      <span className="flex-1">{leadJourney.hunter_name}</span>
                    </div>
                  </div>

                  <div className="flex items-center mt-5">
                    <span className="pb-2 w-full flex">
                      <span className="font-bold w-1/5 text-[#475569]">
                        Qualified for payout
                      </span>
                      <input
                        type="checkbox"
                        checked={formData.payout === 1}
                        onChange={handlePayoutCheckboxChange}
                        disabled={!isEditing}
                        className="h-5 w-5 !text-blue-600 rounded focus:ring-blue-500"
                        // className="custom-checkbox"
                        // className="
                        //     h-5 w-5 appearance-none rounded border-2 border-gray-300
                        //     checked:border-blue-500 checked:bg-blue-500
                        //     focus:ring-2 focus:ring-blue-200 focus:ring-offset-0
                        //     hover:border-blue-400
                        //     transition-colors duration-200
                        // "
                      />
                    </span>
                  </div>
                </div>
              </div>
            )}

            {/* Referrer Details for Referral Active Section */}
            {leadJourney.lead_source === "Referral Active" && (
              <div>
                <div className="flex justify-between">
                  <div className="flex items-center">
                    <p className="font-bold text-lg md:text-2xl">Referrer Details</p>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3 md:gap-x-5 ml-2 md:ml-5 items-start mb-5">
                  <div className="flex items-start mt-5">
                    <div className="border-b border-gray-200 pb-2 w-full flex">
                      <span className="w-1/3">
                        <b>Referrer</b>
                      </span>
                          <span>{leadJourney.referrer}</span>
                        </div>
                  </div>

                  <div className="flex items-start mt-5">
                    <div className="border-b border-gray-200 pb-2 w-full flex">
                      <span className="w-1/3">
                        <b>Lead Owner</b>
                      </span>
                      <span className="flex-1">{leadJourney.hunter_name}</span>
                    </div>
                  </div>

                  {/* Bank Name & Account Number */}
                  <div className="flex items-start mt-5">
                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/3"><b>Bank Name</b></span>
                        {isEditing ? (
                            <input
                                type="text"
                                name="referrer_bank_name"
                                value={formData.referrer_bank_name || ''}
                                onChange={handleChange}
                                className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                            />
                        ) : (
                            <span className="flex-1">{leadJourney.referrer_bank_name}</span>
                        )}
                        <button
                            onClick={() => {
                                navigator.clipboard.writeText(leadJourney.referrer_bank_name);
                                toast.success('Copied to clipboard!');
                            }}
                            className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                                <img src="/icons/content_copy.svg" className='size-6'/>
                        </button>
                    </div>
                  </div>
                  <div className="flex items-start mt-5">
                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/3"><b>Bank Account Name</b></span>
                        {isEditing ? (
                            <input
                                type="text"
                                name="referrer_bank_acc_name"
                                value={formData.referrer_bank_acc_name || ''}
                                onChange={handleChange}
                                className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                            />
                        ) : (
                            <span className="flex-1">{leadJourney.referrer_bank_acc_name}</span>
                        )}
                        <button
                            onClick={() => {
                                navigator.clipboard.writeText(leadJourney.referrer_bank_acc_name);
                                toast.success('Copied to clipboard!');
                            }}
                            className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                                <img src="/icons/content_copy.svg" className='size-6'/>
                        </button>
                    </div>
                  </div>
                  <div className="flex items-start mt-5">
                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/3"><b>Bank Account Number</b></span>
                        {isEditing ? (
                            <input
                                type="text"
                                name="referrer_bank_acc_no"
                                value={formData.referrer_bank_acc_no || ''}
                                onChange={handleChange}
                                className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                            />
                        ) : (
                            <span className="flex-1">{leadJourney.referrer_bank_acc_no}</span>
                        )}
                        <button
                            onClick={() => {
                                navigator.clipboard.writeText(leadJourney.referrer_bank_acc_no);
                                toast.success('Copied to clipboard!');
                            }}
                            className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                                <img src="/icons/content_copy.svg" className='size-6'/>
                        </button>
                    </div>
                  </div>

                  <div className="flex items-center mt-5">
                    <span className="pb-2 w-full flex">
                      <span className="font-bold w-1/5 text-[#475569]">
                        Qualified for payout
                      </span>
                      <input
                        type="checkbox"
                        checked={formData.payout === 1}
                        onChange={handlePayoutCheckboxChange}
                        disabled={true}
                        className="h-5 w-5 !text-blue-600 rounded focus:ring-blue-500"
                        // className="custom-checkbox"
                        // className="
                        //     h-5 w-5 appearance-none rounded border-2 border-gray-300
                        //     checked:border-blue-500 checked:bg-blue-500
                        //     focus:ring-2 focus:ring-blue-200 focus:ring-offset-0
                        //     hover:border-blue-400
                        //     transition-colors duration-200
                        // "
                      />
                    </span>
                  </div>
                </div>
              </div>
            )}

            {/* Referrer Details for the rest of Referral Section */}
            {["Referral Public", "Referral F&F", "Referral Special", "Referral Hunter", "Referral Hunter - Active", "Referral Active - Legacy"].includes(leadJourney.lead_source) && (
              <div>
                <div className="flex justify-between">
                  <div className="flex items-center">
                    <p className="font-bold text-lg md:text-2xl">Referrer Details</p>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3 md:gap-x-5 ml-2 md:ml-5 items-start mb-5">
                  <div className="flex items-start mt-5">
                    <div className="border-b border-gray-200 pb-2 w-full flex">
                      <span className="w-1/3">
                        <b>Lead Owner</b>
                      </span>
                      <span className="flex-1">{leadJourney.hunter_name}</span>
                    </div>
                  </div>
                  <div className="flex items-start mt-5">
                    <div className="border-b border-gray-200 pb-2 w-full flex">
                      <span className="w-1/3">
                        <b>Referrer Name</b> <a className="text-[#DD3730]">*</a>
                      </span>
                      {isEditing ? (
                        <input
                          type="text"
                          name="referrer_name"
                          value={formData.referrer_name || ""}
                          onChange={handleChange}
                          className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                        />
                      ) : (
                        <div className="flex-1 flex items-center">
                          <span>{leadJourney.referrer_name}</span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="flex items-start mt-5">
                    <p className="border-b border-gray-200 pb-2 w-full flex">
                      <span className="w-1/3">
                        <b>Referrer Company</b>
                      </span>
                      {isEditing ? (
                        <input
                          type="text"
                          name="referrer_company"
                          value={formData.referrer_company || ""}
                          onChange={handleChange}
                          className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                        />
                      ) : (
                        <div className="flex-1 flex items-center">
                          <span>{leadJourney.referrer_company}</span>
                        </div>
                      )}
                    </p>
                  </div>

                  <div className="flex items-start mt-5">
                    <div className="border-b border-gray-200 pb-2 w-full flex">
                      <span className="w-1/3">
                        <b>Referrer Contact</b>
                      </span>
                      {isEditing ? (
                        <input
                          type="text"
                          name="referrer_contact"
                          value={formData.referrer_contact || ""}
                          onChange={handleChange}
                          className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                        />
                      ) : (
                        <div className="flex-1 flex items-center">
                          <span>{leadJourney.referrer_contact}</span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="flex items-start mt-5">
                    <div className="border-b border-gray-200 pb-2 w-full flex">
                      <span className="w-1/3">
                        <b>Referrer Email</b>
                      </span>
                      {isEditing ? (
                        <input
                          type="text"
                          name="referrer_email"
                          value={formData.referrer_email || ""}
                          onChange={handleChange}
                          className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                        />
                      ) : (
                        <div className="flex-1 flex items-center">
                          <span>{leadJourney.referrer_email}</span>
                        </div>
                      )}
                    </div>
                  </div>
                  {['Referral Public'].includes(leadJourney.lead_source) ? (
                    <div className="flex items-start mt-5">
                      <div className="border-b border-gray-200 pb-2 w-full flex">
                        <span className="w-1/3">
                          <b>Referrer Code</b>
                        </span>
                        {isEditing ? (
                          <input
                            type="text"
                            name="referrer_code"
                            value={formData.referrer_code || ""}
                            onChange={handleChange}
                            className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                          />
                        ) : (
                          <div className="flex-1 flex items-center">
                            <span>{leadJourney.referrer_code}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  ): null}

                  {/* Bank Name & Account Number */}
                  <div className="flex items-start mt-5">
                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/3"><b>Bank Name</b></span>
                        {isEditing ? (
                            <input
                                type="text"
                                name="referrer_bank_name"
                                value={formData.referrer_bank_name || ''}
                                onChange={handleChange}
                                className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                            />
                        ) : (
                            <span className="flex-1">{leadJourney.referrer_bank_name}</span>
                        )}
                        <button
                            onClick={() => {
                                navigator.clipboard.writeText(leadJourney.referrer_bank_name);
                                toast.success('Copied to clipboard!');
                            }}
                            className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                                <img src="/icons/content_copy.svg" className='size-6'/>
                        </button>
                    </div>
                  </div>
                  <div className="flex items-start mt-5">
                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/3"><b>Bank Account Name</b></span>
                        {isEditing ? (
                            <input
                                type="text"
                                name="referrer_bank_acc_name"
                                value={formData.referrer_bank_acc_name || ''}
                                onChange={handleChange}
                                className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                            />
                        ) : (
                            <span className="flex-1">{leadJourney.referrer_bank_acc_name}</span>
                        )}
                        <button
                            onClick={() => {
                                navigator.clipboard.writeText(leadJourney.referrer_bank_acc_name);
                                toast.success('Copied to clipboard!');
                            }}
                            className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                                <img src="/icons/content_copy.svg" className='size-6'/>
                        </button>
                    </div>
                  </div>
                  <div className="flex items-start mt-5">
                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/3"><b>Bank Account Number</b></span>
                        {isEditing ? (
                            <input
                                type="text"
                                name="referrer_bank_acc_no"
                                value={formData.referrer_bank_acc_no || ''}
                                onChange={handleChange}
                                className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                            />
                        ) : (
                            <span className="flex-1">{leadJourney.referrer_bank_acc_no}</span>
                        )}
                        <button
                            onClick={() => {
                                navigator.clipboard.writeText(leadJourney.referrer_bank_acc_no);
                                toast.success('Copied to clipboard!');
                            }}
                            className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                                <img src="/icons/content_copy.svg" className='size-6'/>
                        </button>
                    </div>
                  </div>

                  <div className="flex items-center">
                    <div className="flex">
                      <span className="flex items-center mt-4">
                        <span className="font-bold mr-2">
                          Qualified for payout
                        </span>
                        <input
                          type="checkbox"
                          checked={formData.payout === 1}
                          onChange={handlePayoutCheckboxChange}
                          disabled={!isEditing || ["Referral F&F", "Referral Special"].includes(leadJourney.lead_source)}
                          className="h-4 w-5 text-blue-600 rounded focus:ring-blue-500"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === 1 && (
          <InfoGatheringTab leadID={leadID} leadOwner={leadOwner} onRefetch={refetch} leadStatus = {leadJourney.status}/>
        )}

        {activeTab === 2 && (
          <>
          {/* Securitry Issues -> Exclided upload documents */}
            {/* <DocumentTab leadID={leadID} /> */}
            <AdditionalDetails
              leadOwner={leadOwner}
              leadID={leadID}
              fromOpp={fromOpp}
              canViewLead={canViewLead}
            />
          </>
        )}
      </div>

      {showReassignModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4">
          <div className="bg-white p-4 md:p-6 rounded-lg w-full md:w-2/3 lg:w-1/3 max-h-[90vh] overflow-y-auto">
            <span className="flex-1 -ml-1 inline-flex items-center">
              <img src="/icons/edit.svg" className="w-5 h-5 md:w-6 md:h-6 mr-2" />
              <h2 className="text-lg md:text-xl font-bold mb-1">
                Reassign owner to someone else?
              </h2>
            </span>
            <p className="border-b border-gray-200 w-full flex mb-4"></p>

            <p className="text-sm md:text-base">Current lead owner</p>
            <input
              type="text"
              className="w-full p-3 md:p-2 border border-gray-300 rounded mb-4 mt-1 bg-gray-100 text-sm md:text-base min-h-[44px] md:min-h-0"
              value={leadJourney.hunter_name}
              readOnly
            />

            <p className="text-sm md:text-base">Reassign to</p>
            <select
              className="w-full p-3 md:p-2 border border-gray-300 rounded mb-4 mt-1 text-sm md:text-base min-h-[44px] md:min-h-0"
              value={selectedHunter}
              onChange={(e) => setSelectedHunter(e.target.value)}
            >
              <option value="">Select from list</option>
              {hunterList.map((hunter) => (
                <option key={hunter.id} value={hunter.username}>
                  {hunter.username}
                </option>
              ))}
            </select>
            <div className="flex flex-col md:flex-row justify-end gap-2 md:space-x-2">
              <button
                className="bg-white text-black py-3 px-4 rounded-3xl border-[1px] border-black hover:bg-gray-100 min-h-[44px] order-2 md:order-1"
                onClick={() => setShowReassignModal(false)}
              >
                <b>Cancel</b>
              </button>
              <button
                className="bg-yellow-300 text-black py-3 px-4 md:px-8 rounded-3xl hover:bg-yellow-400 min-h-[44px] order-1 md:order-2"
                onClick={handleReassignSubmit}
              >
                <b>Continue</b>
              </button>
            </div>
          </div>
        </div>
      )}

      {showConfirmationModal && (
        <div className="fixed z-[60] inset-0 bg-black bg-opacity-50 flex items-center justify-center text-center p-4">
          <div className="bg-white p-4 md:p-6 rounded-lg w-full md:w-2/3 lg:w-1/4 max-h-[90vh] overflow-y-auto">
            {/* Center the icon using Flexbox */}
            <div className="flex justify-center mb-2 pt-4 md:pt-6">
              <img src="/icons/edit.svg" className="w-9 h-9 md:w-11 md:h-11" />
            </div>

            <h1 className="text-xl md:text-2xl font-bold mb-3">Save & Update Owner</h1>
            <p className="text-sm md:text-base">
              Previous owner ({leadJourney.hunter_name}) will be updated. Please
              ensure selected new owner ({selectedHunter}) are correct.
            </p>
            <div className="mt-6 mb-6">
              <button
                className="text-black underline hover:text-blue-800 focus:outline-none min-h-[44px] flex items-center justify-center mx-auto"
                onClick={handleConfirmationCancel}
              >
                <b>No, Don't Update</b>
              </button>
            </div>
            <button
              className="bg-yellow-300 text-black py-4 w-full rounded-3xl hover:bg-yellow-400 min-h-[44px]"
              onClick={handleConfirmationSubmit}
            >
              <b>Save & Update</b>
            </button>
          </div>
        </div>
      )}
      {showReassignConfirmationModal && (
        <div className="fixed z-[60] inset-0 bg-black bg-opacity-50 flex items-center justify-center text-center p-4">
          <div className="bg-white p-4 md:p-6 rounded-lg w-full md:w-2/3 lg:w-1/4 max-h-[90vh] overflow-y-auto">
            {/* Center the icon using Flexbox */}
            <div className="flex justify-center mb-2 pt-4 md:pt-6">
              <img src="/icons/edit.svg" className="w-9 h-9 md:w-11 md:h-11" />
            </div>

            <h1 className="text-xl md:text-2xl font-bold mb-3">Save & Update Details</h1>
            <p className="text-sm md:text-base">
              Lead details will be updated. Please ensure new details are
              correct.
            </p>
            <div className="mt-6 mb-6">
              <button
                className="text-black underline hover:text-blue-800 focus:outline-none min-h-[44px] flex items-center justify-center mx-auto"
                onClick={handleConfirmationCancel}
              >
                <b>No, Don't Update</b>
              </button>
            </div>
            <button
              className="bg-yellow-300 text-black py-4 w-full rounded-3xl hover:bg-yellow-400 min-h-[44px]"
              onClick={handleReassignConfirmation}
            >
              <b>Save & Update</b>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
